import { Grid } from "@mui/material";
import React from "react";
import MessageBox from "./MessageBox";
import AllUsers from "./Users";
import io from "socket.io-client";
import { socketUrl } from "../../services";

const socket = io.connect(socketUrl);
// const socket = io.connect("https://sirldigital.com/service_provider/");

function Chat() {
  return (
    <Grid
      container
      spacing={1}

      // height={"80vh"}
    >
      <Grid item xs={12} md={3.5}>
        <AllUsers socket={socket} />
      </Grid>
      <Grid item xs={12} md={8.5} sx={{ display: { xs: "none", md: "block" } }}>
        <MessageBox socket={socket} />
      </Grid>
    </Grid>
  );
}

export default Chat;
